import axios from 'axios'
import EventBus from '../components/EventBus.js'
var Design = {};
var _baseURL = process.env.VUE_APP_AUTH_API + '/designs'
Design.install = function(Vue) {
  Vue.prototype.$design = {
    submitRegistration(data, callback, errorCallback) {
      axios({
        method: 'POST',
        url: _baseURL,
        data,
        withCredentials: true,
      }).then(
        (response) => callback(response),
        (error) => errorCallback(error.response.data)
      )
    },
    fetchDesigns(params) {
      axios({
        method: 'GET',
        url: _baseURL,
        params: params,
        withCredentials: true,
      }).then(
        (response) => { EventBus.$emit('designs-fetched', response.data) },
      )
    },
    fetchDesignRegistration(designId, callback, errorCallback) {
      axios({
        method: 'GET',
        url: _baseURL + '/' + designId,
        withCredentials: true,
      }).then(
        (response) => callback(response),
        (error) => errorCallback(error.response.data)
      )
    },
    updateDesign(designId, data, errorCallback) {
      axios({
        method: 'PATCH',
        url: _baseURL + '/' + designId,
        data,
        withCredentials: true,
      }).then(
        (response) => { EventBus.$emit('design-fetched', response.data) },
        (error) => { errorCallback(error.response.data) },
      )
    },
    fetchDesign(designId) {
      axios({
        method: 'GET',
        url: _baseURL + '/' + designId,
        withCredentials: true,
      }).then(
        (response) => { EventBus.$emit('design-fetched', response.data) },
      )
    },
    destroyDesign(designId, callback, errorCallback) {
      axios({
        method: 'DELETE',
        url: _baseURL + '/' + designId,
        withCredentials: true,
      }).then(
        (response) => { callback(response.data) },
        (error) => { errorCallback(error.response.data) },
      )
    },
    publishDraft(designId, data, callback, errorCallback) {
      axios({
        method: 'POST',
        url: _baseURL + '/' + designId + '/publish',
        data,
        withCredentials: true,
      }).then(
        (response) => { callback(response.data) },
        (error) => { errorCallback(error.response.data) },
      )
    },
    unpublishProduct(designId, callback, errorCallback) {
      axios({
        method: 'POST',
        url: _baseURL + '/' + designId + '/unpublish',
        withCredentials: true,
      }).then(
        (response) => { callback(response.data) },
        (error) => { errorCallback(error.response.data) },
      )
    },
    createDesign(data, callback, errorCallback) {
      axios({
        method: 'POST',
        url: _baseURL,
        data,
        withCredentials: true,
      }).then(
        (response) => { callback(response.data) },
        (error) => { errorCallback(error.response.data) },
      )
    },
    getContactPoint(vendorId, callback) {
      axios({
        method: 'GET',
        url: _baseURL + '/contact_point',
        params: { vendorId },
        withCredentials: true,
      }).then(
        (response) => { callback(response.data) },
      )
    },
    migrateLegacy(listing, callback, errorCallback) {
      axios({
        method: 'POST',
        url: _baseURL + `/${listing.id}/migrate_legacy`,
        withCredentials: true,
      }).then(
        (response) => { callback(response.data) },
        (error) => { errorCallback(error) },
      )
    }
  }
}

export default Design;
